const About = () => {
  return (
    <section data-testid="about-section" className="py-24 px-6 bg-[#0D0D0D]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image */}
          <div className="relative group" data-testid="about-image-container">
            <div className="absolute inset-0 bg-gradient-to-r from-[#00E600]/20 to-[#36E0A8]/20 rounded-lg transform group-hover:scale-105 transition-transform duration-300"></div>
            <img 
              src="https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc2MTA0Njc0OHww&ixlib=rb-4.1.0&q=85"
              alt="AI Neural Network"
              className="relative rounded-lg shadow-2xl w-full h-auto"
            />
          </div>

          {/* Content */}
          <div data-testid="about-content">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase tracking-wide">
              About <span className="text-[#00E600]">NYAXO</span>
            </h2>
            <div className="space-y-5 text-[#B3B3B3] text-lg leading-relaxed">
              <p className="text-white font-semibold text-xl">
                Nyaxo is a Singapore-based AI and machine learning company focused on building intelligent systems that help organizations automate decisions, forecast outcomes, and operate with real-time clarity.
              </p>
              <p>
                Our platform and solutions are designed for companies that need reliable, production-grade AI — not prototypes or experiments. The team behind Nyaxo combines expertise in data science, machine learning, distributed systems, and enterprise software engineering. With experience across APAC, the Middle East, and Europe, our specialists deliver solutions that are technically robust and operationally practical.
              </p>
              <p>
                We believe AI should be <span className="text-[#00E600] font-semibold">simple to deploy, transparent to understand, and powerful enough to transform</span> how modern businesses operate.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3 md:gap-6 mt-8">
              <div className="text-center" data-testid="stat-projects">
                <div className="text-2xl md:text-3xl font-bold text-[#00E600]">500+</div>
                <div className="text-xs md:text-sm text-[#B3B3B3] mt-1">Projects</div>
              </div>
              <div className="text-center" data-testid="stat-clients">
                <div className="text-2xl md:text-3xl font-bold text-[#00E600]">200+</div>
                <div className="text-xs md:text-sm text-[#B3B3B3] mt-1">Clients</div>
              </div>
              <div className="text-center" data-testid="stat-countries">
                <div className="text-2xl md:text-3xl font-bold text-[#00E600]">50+</div>
                <div className="text-xs md:text-sm text-[#B3B3B3] mt-1">Countries</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;